<template>
    <div>
        <nav-secondary :navOptionSections="navOptionSections"></nav-secondary>
        <router-view class="flex-page-content flex-container view"/>
    </div>
</template>

<script>
import NavSecondary from '@/components/NavSecondary'

export default {
    components: { NavSecondary, },
    computed: {
        navOptionSections() {
            return [
                {
                    options: [
                        {'text': 'Processing Today', 'value': 'daily-payroll-processing'},
                        {'text': 'To Print', 'value': 'daily-payroll-to-print', 'badge': this.readyToPrintCount},
                        {'text': 'Printed', 'value': 'daily-payroll-printed'},
                    ],
                },
                {
                    divider: true,
                    options: [
                        {'text': 'Files to Create', 'value': 'daily-payroll-files-to-create'},
                        {'text': 'Created Files', 'value': 'daily-payroll-created-files'},
                    ],
                },
            ]
        },
    },
    data() {
        return {
            readyToPrintCount: 0,
        }
    },
    mounted() {
        const routes = this.navOptionSections.flatMap(sec => sec.options.map(o => o.value))
        if (routes.indexOf(this.$route.name) < 0) {
            this.$router.replace({name: routes[0]})
        }

        this.getReadyToPrintCount()
        this.$bus.$on('daily_payroll_updated', this.getReadyToPrintCount)
    },
    beforeUnmount() {
        this.$bus.$off('daily_payroll_updated', this.getReadyToPrintCount)
    },
    methods: {
        getReadyToPrintCount() {
            this.$api.get('/admin/daily-payroll/to-print').then(resp => {
                this.readyToPrintCount = resp.print_groups.filter(group => {
                    return !group.hold_until_time || (new Date(group.hold_until_time) <= new Date())
                }).length
            }).catch(() => {
                // The badge is non-critical; the page itself surfaces any API errors.
            })
        },
    },
}
</script>
